
import init, {AgentManager} from "wasm-lib";
await init()


const isPreviewMode = (new URLSearchParams(window.location.search)).get('preview') === "1"
const seed = ~~(fxrand() * 123456789)

const alphabet = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
const char=alphabet[seed%alphabet.length]
var canvas = document.createElement("canvas");
canvas.height = window.innerHeight
canvas.width = window.innerWidth
var agent_manager=null
var context=canvas.getContext("2d")

document.body.appendChild(canvas);

window.addEventListener('resize', () => {
    canvas.width = window.innerWidth
    canvas.height = window.innerHeight
    start(context)
})

canvas.addEventListener('click', () => {
  canvas.toBlob((blob) => {
    saveBlob(blob, `screencapture-${canvas.width}x${canvas.height}.png`);
  });
});
 
const saveBlob = (function() {
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style.display = 'none';
  return function saveData(blob, fileName) {
     const url = window.URL.createObjectURL(blob);
     a.href = url;
     a.download = fileName;
     a.click();
  };
}());


function draw(){
    agent_manager.next(context)
    window.requestAnimationFrame(draw)

}
function start() {
    var ctx = canvas.getContext("2d");
    agent_manager=AgentManager.message(canvas.width,canvas.height,char,seed)
    ctx.fillStyle = "#FF0000";
    ctx.fillRect(0, 0, canvas.width, canvas.height)
    window.requestAnimationFrame(draw)


}
start()


